/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * An adaptor metadata layer that help to work with difference format of video metadata with a single interface
 */
export class Metadata {
  /**
   * Constructor
   *
   * @param {object} metadata The video oembed metadata
   * @param {object} params   Additional video parameters
   * @param {string} params.type Type of video provider, supported: vimeo, youtube.
   * @param {string} params.video_id The video ID
   */
  constructor(metadata, { type, video_id }) { // eslint-disable-line camelcase
    this.metadata = metadata;
    this.type = type;
    this.video_id = video_id; // eslint-disable-line camelcase

    // Temporary hard-coded for Youtube dimension as it isn't response correct value
    if (this.youtube) {
      this.metadata.width = 16;
      this.metadata.height = 9;
    }
  }

  /**
   * @returns {string} The video ID
   */
  get id() {
    return this.video_id;
  }

  /**
   * @returns {string} The embed HTML code
   */
  get html() {
    return this.metadata.html;
  }

  /**
   * @returns {string} Default thumbnail image url
   */
  get thumbnail() {
    switch (this.type) {
      case 'vimeo': return this.metadata.thumbnail_url;
      case 'youtube': return `//i.ytimg.com/vi/${this.video_id}/mqdefault.jpg`;
      case 'html': return this.metadata.thumbnail_url;
    }
  }

  /**
   * @returns {number} Video width
   */
  get width() {
    return this.metadata.width;
  }

  /**
   * @returns {number} Video height
   */
  get height() {
    return this.metadata.height;
  }

  /**
   * @returns {number}
   */
  get ratio() {
    return this.width / this.height;
  }

  /**
   * @returns {boolean} `true` if current metadata is provided by Vimeo
   */
  get vimeo() {
    return this.type === 'vimeo';
  }

  /**
   * @returns {boolean} `true` if current metadata is provided by Youtube
   */
  get youtube() {
    return this.type === 'youtube';
  }
}
